import Backbone from 'backbone';
import Utils from '../utils';
import UserModel from '../models/model.user';
import UsernameModel from '../models/model.username';
import SecurityQuestionSetupModel from '../models/model.securityQuestionSetup';
import EnrollView from '../views/view.enroll';
import UsernameView from '../views/view.usernamePassword';
import SecurityQuestionSetupView from '../views/view.securityQuestionSetup';
import SizzleWyzardView from '../views/view.sizzleWyzard';
import ProfileView from '../views/view.profile';
import SpinnerView from '../views/view.spinner';
import ConfirmationView from '../views/view.confirmation';
import {
  templateUrls
} from './../../../base/vars.js';

export default Backbone.Router.extend({
  routes: {
    '': 'enroll',
    'username': 'usernamePassword',
    'security': 'securityQuestionSetup',
    'book': 'profile',
    'spinner': 'spinner',
    'confirmation': 'confirmation'
  },

  initialize() {
    Utils.extendBackboneValidation();
  },

  execute(callback, args) {
    Utils.scrollToTop();
    if (callback) callback.apply(this, args);
  },

  checkValidUser(prop) {
    if (prop) {
      return window.App.Collections.Users.models &&
        window.App.Collections.Users.models[0] &&
        window.App.Collections.Users.models[0].get(prop) &&
        window.App.Collections.Users.models[0].get(prop).length > 0;
    } else {
      return true;
    }
  },

  enroll() {
    Utils.emptyApp();
    this.view = new EnrollView({
      model: new UserModel()
    });
  },

  usernamePassword() {
    let objGDPR;
    if (this.checkValidUser('resetPwToken')) {
      Utils.destroy(this.view);
      if (this.checkValidUser('country')) {
        objGDPR = Utils.getGdprObjFtsi();
      } else {
        objGDPR = Utils.getGdprObjEnroll();
      }
      this.view = new UsernameView({
        model: new UsernameModel(objGDPR)
      });

    } else {
      Backbone.history.loadUrl('');
    }
  },

  securityQuestionSetup() {
    if (this.checkValidUser('TwoFormActionCode')) {
      Utils.destroyStep(this.view);
      this.sizzleView = new SizzleWyzardView({
        url: templateUrls.sizzleWyzardSecurity
      });
      this.view = new SecurityQuestionSetupView({
        model: new SecurityQuestionSetupModel()
      });
    } else {
      Backbone.history.loadUrl('');
    }
  },

  profile() {
    if (this.checkValidUser('TwoFormActionCode')) {
      Utils.destroyStep(this.view);
      Utils.destroyStep(this.sizzleView);
      this.sizzleView = new SizzleWyzardView({
        url: templateUrls.sizzleWyzardProfile
      });
      this.view = new ProfileView({
        model: window.App.Collections.Users.models[0]
      });
    } else {
      Backbone.history.loadUrl('');
    }
  },

  spinner() {
    if (this.checkValidUser('TwoFormActionCode')) {
      Utils.emptyApp();
      Utils.destroyStep(this.view);
      this.view = new SpinnerView({
        model: window.App.Collections.Users.models[0]
      });
    } else {
      Backbone.history.loadUrl('');
    }
  },

  confirmation() {
    if (this.checkValidUser('TwoFormActionCode')) {
      Utils.emptyApp();
      Utils.destroyStep(this.view);
      this.view = new ConfirmationView({
        model: window.App.Collections.Users.models[0]
      });
    } else {
      Backbone.history.loadUrl('');
    }
  }
});
